import { sortBy } from '@vydaps/gui-commons/arrays';
import { CtDocument } from '../model/ct-batch-model';

function getOrderValueByDocumentClass(documentClass: string) {
  return (
    {
      '25_Q3_ANSCHREIBEN': 0,
      '25_Q3_SCHADENANZEIGE': 1,
      '25_Q3_FORDERUNGSAUFSTELLUNG': 2,
      '25_Q3_SONSTIGES': 999,
    }[documentClass] ?? 3
  );
}

export function getSortedDocuments(documents: CtDocument[]): CtDocument[] {
  return sortBy(documents, (document) =>
    // We sort by the minimum sort value of all document classes. So ANSCHREIBEN+FORDERUNGSAUFSTELLUNG would
    // still be sorted to the top.
    Math.min(
      ...document.documentClasses.map((documentClass) =>
        getOrderValueByDocumentClass(documentClass),
      ),
    ),
  );
}
